import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';

@Component({
  selector: 'table-column-boolean',
  templateUrl: './table-column-boolean.component.html',
  standalone: false,
})
export class TableColumnBooleanComponent<T> implements OnChanges {
  @Input() element: T;

  @Input() displayValue: string;

  @Input() iconName?: string | UnaryFunction<T, string>;

  @Input() cssClass?: string | UnaryFunction<T, string>;

  @Input() tooltip?: string | UnaryFunction<T, string>;

  @Input() noSdxIcon?: boolean | UnaryFunction<T, boolean>;

  @Input() hidden?: boolean | UnaryFunction<T, boolean>;

  @Input() tooltipClass?: boolean | UnaryFunction<T, boolean>;

  @Input() disabled: boolean | UnaryFunction<T, boolean> = false;

  @Input() columnCssClass?: string; // unused, fixes console error after angular update

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  static readonly sortEnabled = false;

  icon: string;

  ngOnChanges(changes: SimpleChanges): void {
    const { element } = changes;
    if (element.currentValue[this.displayValue]) {
      this.icon = 'check-mark';
    } else {
      this.icon = 'minus';
    }
  }
}
